
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 6 19 16\" id=\"twitter_0b3cb4fd964d541caa34a806e8deb2b4\" ><title>Twitter</title><path d=\"M18.065 7.776a7.259 7.259 0 0 1-2.129.596 3.78 3.78 0 0 0 1.63-2.095 7.315 7.315 0 0 1-2.355.918A3.66 3.66 0 0 0 12.506 6c-2.045 0-3.704 1.696-3.704 3.787 0 .296.031.585.095.862-3.08-.158-5.81-1.664-7.64-3.958a3.845 3.845 0 0 0-.501 1.906c0 1.313.654 2.472 1.649 3.152a3.648 3.648 0 0 1-1.68-.473v.047c0 1.835 1.278 3.366 2.974 3.713a3.647 3.647 0 0 1-1.674.066c.472 1.504 1.84 2.599 3.462 2.628A7.334 7.334 0 0 1 0 19.3C1.64 20.373 3.59 21 5.681 21c6.818 0 10.545-5.77 10.545-10.774 0-.164-.003-.329-.01-.49a7.59 7.59 0 0 0 1.849-1.96\" fill=\"currentColor\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "twitter_0b3cb4fd964d541caa34a806e8deb2b4");


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/sprite/twitter.svg
 ** module id = 224
 ** module chunks = 0
 **/